import React, {Dispatch, ReactNode, SetStateAction} from "react";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
} from "@mui/material";
import {AccordionProps} from "@mui/material/Accordion/Accordion";
import {AccordionDetailsProps} from "@mui/material/AccordionDetails/AccordionDetails";
import {AccordionSummaryProps} from "@mui/material/AccordionSummary/AccordionSummary";

export interface LazyAccordionProps {
	readonly containerProps?: Omit<AccordionProps, "children">;
	readonly summaryProps?: Omit<AccordionSummaryProps, "children">;
	readonly detailsProps?: Omit<AccordionDetailsProps, "children">;
	readonly summary: ReactNode;
	readonly children: ReactNode;
	readonly onOpened?: Dispatch<SetStateAction<boolean>>;
}

/**
 * <Accordion> replacement with lazy rendering of child elements
 * to avoid performance issues when there are too many elements in the html even though they start hidden.
 */
export function LazyAccordion(props: LazyAccordionProps) {
	const [loaded, setLoaded] = React.useState(false);
	const [open, setOpen] = React.useState(false);
	
	return <Accordion {...props.containerProps}>
		<AccordionSummary {...props.summaryProps} onClick={event => {
			setLoaded(true);
			
			if (props.onOpened) {
				const newState = !open;
				setOpen(newState);
				props.onOpened(newState);
			}
			
			if (props.summaryProps?.onClick)
				props.summaryProps.onClick(event);
		}}>
			{props.summary}
		</AccordionSummary>
		<AccordionDetails {...props.detailsProps}>
			{loaded && props.children}
		</AccordionDetails>
	</Accordion>;
}
